import { useMutation, useQueryClient } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { createContract } from "../services/goHireService";
import { CreateContractPayload } from "../types/contract.types";

export const useCreateContract = (requestId: number, options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateContractPayload) => createContract(payload),
    mutationKey: GO_SERVICE_QUERY_KEYS.contract(),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: GO_SERVICE_QUERY_KEYS.serviceRequest(requestId) });
      options?.onSuccess?.();
    },
    onError: () => {},
  });
};
